import { render } from "./ParentParticipantGrid.vue?vue&type=template&id=4b2f6260&scoped=true&ts=true"
import script from "./ParentParticipantGrid.vue?vue&type=script&lang=ts"
export * from "./ParentParticipantGrid.vue?vue&type=script&lang=ts"

import "./ParentParticipantGrid.vue?vue&type=style&index=0&id=4b2f6260&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2f6260"]])

export default __exports__